module.exports = __webpack_public_path__ + "img/10023.590c540a.png";